import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { getReferentielDataFromServer } from "../../../common/components/general/AxiosReferencielInterceptor";
import JwtUtils from "../../../common/router/JwtUtils";
import AssistantBot from "../components/AssistantBot";

const PGUAssistantBot = (props) => {
  const {
    isMobile,
    mode,
    setMode,
    sessionActive,
    setSessionActive,
    handleClose,
    handleDestroy,
    source,
    isExpanded = false,
    isRecording,
    speechSupported,
    startRecording,
    stopRecording,
    inputMessage,
    setInputMessage,
  } = props;
  const [token, setToken] = useState(null);
  useEffect(() => {
    const handleMessage = async (event) => {
      // Check if message contains token
      if (event.data && event.data.type === "SET_TOKEN") {
        const token = event.data.token;
        await getReferentielDataFromServer(false, "api/user/get-token", {
          accessToken: token,
          source: "pmpce",
        })
          .then((token) => {
            if (token?.error) {
              console.error("Error fetching user info:", token);
              return;
            }
            setToken(token);
            event.source.postMessage(
              {
                type: "TOKEN_RECEIVED",
                token: token,
                status: "success",
              },
              event.origin
            );
          })
          .catch((error) => {
            console.error("Error fetching user info:", error);
          });
      }

      if (event.data && event.data.type === "CONVERSATION_SELECTED") {
        if(!!event.data.sessionId)
          setSessionActive(event.data.sessionId);
        
      }
    };

    // Add event listener
    window.addEventListener("message", handleMessage);

    // Cleanup
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  const addToHistory = async (history) => {
    if (
      !(
        !!token &&
        token !== "undefined" &&
        token !== "null" &&
        Object.keys(token).length > 0 &&
        !JwtUtils.isExpired(token)
      )
    )
      return;
    getReferentielDataFromServer(
      false,
      "api/user/addToUserHistory",
      {
        title: history.title,
        sessionId: history.id,
      },
      "post",
      token
    ).then((res) => {
      if (res?.error) {
        if (res?.status === 403) {
          return;
        }
        console.error("res", res);
        return;
      }
    });
  };

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        right: 0,
        bottom: 0,
        width: { xs: "100vw", sm: "400px", md: "450px", lg: "500px" },
        backgroundColor: "white",
        boxShadow: "-2px 0 8px rgba(0, 0, 0, 0.1)",
        display: "flex",
        flexDirection: "column",
        zIndex: 1300,
      }}
    >
      {/* Chat Content - Pass hideHeader prop to avoid double header */}
      <Box sx={{ flex: 1, minHeight: 0, overflow: "auto" }}>
        <AssistantBot
          isMobile={isMobile}
          isExpanded={isExpanded}
          mode={mode}
          setMode={setMode}
          sessionActive={sessionActive}
          setSessionActive={(e) => setSessionActive(e)}
          handleClose={handleClose}
          handleDestroy={handleDestroy}
          hideHeader={true}
          skipLogin={true}
          source={source}
          isRecording={isRecording}
          speechSupported={speechSupported}
          startRecording={startRecording}
          stopRecording={stopRecording}
          inputMessage={inputMessage}
          setInputMessage={setInputMessage}
          addToHistory={addToHistory}
          token={token}
        />
      </Box>
    </Box>
  );
};

export default PGUAssistantBot;
